<template>
    <div class="">
        <h4 class="text-center">Settings</h4>


        <!-- Send Time -->
        <div v-for="(sendTime, index) in $data._settings['sendTimes']"
             class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Times To Send Report Each Day {{ index > 0 ? index + 1 : '' }}</span>
            <date-time-picker
                :id="`auto_send_time_${index}`"
                v-model:model-value="$data._settings['sendTimes'][index]"
                format="h a"
                vertical-position="bottom"
                @update:value="updateSettings($event, 'sendTimes'[index])"
            ></date-time-picker>
        </div>
    </div>

</template>

<script>
import axios from "axios"

import DateTimePicker from "@/components/Reports/DateTimePicker";

import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";

import Select2 from "../elements/select2";

export default {
    name: "RoomConditionReportSettings",
    mixins: [SonicuCoreMixin],
    components: {Select2, DateTimePicker},
    props: {
        settings: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            _receiveWeekday: this.receiveWeekday,
            _semiMonthHalf: this.semiMonthHalf,
            _interval: this.interval,
            isSaving: false,

            month: this.maxDate,
            format: _.indexOf(['monthly', 'semi-monthly'], this.interval) > -1 ? 'MMMM YYYY' : 'MMMM DD, YYYY',
            viewMode: _.indexOf(['monthly', 'semi-monthly'], this.interval) > -1  ? 'months' : 'days',

            selectedUsers: this.selectedUsersInput,
            selectedMeters: [],

            _settings: this.settings,

            showReportModal: false,
            reportModalError: false,
            modalMessage: '',
            modalTitle: '',
            isErrorModal: false,
        }
    },
    created() {
        if (! _.hasIn(this.$data._settings, 'sendTimes')) {
            console.log(`Default Setting send times to []`)
            this.$data._settings['sendTimes'] = []
        }
    },
    mounted() {
        let dates = []
        this.$data._settings['sendTimes'].forEach(hour => {
            console.log(`Hour: `)
            console.log(hour)
            let date = null
            if (_.isInteger(hour)) {
                console.log(`Time is an hour. ${hour}`)
                date = new Date()
                date.setHours(hour)
            }
            else {
                console.log(`Time is a string`)
                date = new Date(hour)
                console.log(`Hour. ${hour}`)
                // date = Date.parse(hour)
            }
            dates.push(_.clone(date))
        })
        console.log(`Date`)
        console.log(dates)
        this.$data._settings['sendTimes'] = dates
    },
    methods: {
        updateSettings(event, triggeringComponent = 'Unknown') {
            // Update the settings values based on the new local

            // // The only setting is sendHours
            // let sendHours = this.$data._settings['sendHours']
            // sendHours.forEach((time, index) => {
            //     sendHours =
            // })

            this.$emit('update:settings', this.$data._settings)
            this.$forceUpdate()
        },
        saveSettings() {
            this.$emit(`saveSettings`)
        },
    },
    computed: {},
    watch: {
        _interval(val, old) {
            if (val !== old) {
                this.$emit('update:interval', this.$data._interval)
            }
        },
        settings (val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
    },
}
</script>

<style scoped>

</style>